import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    props: true,
    //component: Home
    //meta: { transitionName: "slide" },
    component: () =>
      import(/* webpackChunkName: "Home" */ "../views/Home")
  },
  {
    path: "/publication/:slug",
    name: "Publication",
    props: true,
    //meta: { transitionName: "fade" },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Publication" */ "../views/Publication")
  },
  {
    path: "/parution/:slug",
    name: "Parution",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Parution" */ "../views/Parution"),
    children: [
      {
        path: "extrait",
        name: "ParutionExtrait",
        props: true,
        component: () =>
          import(/*webpackChunkName: "ParutionExtrait"*/ "../views/ParutionExtrait")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  linkExactActiveClass: "active",
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
      console.log(to, from, savedPosition, reject);
    })
  }
});

export default router;
